import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-caeafe5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "endpoint-body" }
const _hoisted_2 = { class: "endpoint-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleBar = _resolveComponent("TitleBar")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_EndpointCard = _resolveComponent("EndpointCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleBar, { title: "Endpoints" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageHeader),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.endpoints, (endpoint) => {
          return (_openBlock(), _createBlock(_component_EndpointCard, {
            key: endpoint.id,
            endpoint: endpoint
          }, null, 8, ["endpoint"]))
        }), 128))
      ])
    ])
  ], 64))
}